var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22467 21.4717C2.00859 21.4749 1.79376 21.4406 1.59125 21.3706L11.7944 11.8991L15.1719 15.0367L3.44718 21.1496C3.07578 21.3516 2.65505 21.4624 2.22467 21.4717ZM0.75006 20.6899C0.542649 20.3414 0.439428 19.9477 0.451084 19.5496V2.26309C0.449372 2.00068 0.492122 1.73966 0.577769 1.48957L11.0077 11.1703L0.746259 20.6923L0.75006 20.6899ZM16.179 14.5089L12.5799 11.1714L16.5489 7.48961L20.0746 9.327C20.7513 9.60806 21.2042 10.2144 21.2502 10.9011C21.2044 11.5885 20.751 12.1954 20.0733 12.4763L16.179 14.5089ZM11.7944 10.4379L1.22893 0.634945C1.51902 0.435897 1.87022 0.328364 2.23101 0.328125C2.6571 0.342164 3.07279 0.454047 3.44085 0.653754L15.5405 6.96414L11.7957 10.4379H11.7944Z",
    fill: "#053225"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore1);
export default __webpack_public_path__ + "static/media/playstore1.aef4d2995fb8239eacfaf4cf50356cd1.svg";
export { ForwardRef as ReactComponent };